'use client';

import { createSlatePlugin, type TElement } from 'platejs';

import { clearFieldMarksOnCurrentBlock } from '@/components/editor/clear-field-marks';

function blockHasListStyle(element: TElement | undefined): boolean {
  if (!element) return false;
  const listStyleType = (element as { listStyleType?: string }).listStyleType;
  return typeof listStyleType === 'string' && listStyleType.length > 0;
}

/** Notion-like: new paragraph after Enter starts plain; list items keep active marks. */
export const FieldClearMarksOnBreakPlugin = createSlatePlugin({
  key: 'fieldClearMarksOnBreak',
}).extendEditorTransforms(({ editor, tf: { insertBreak } }) => ({
  insertBreak() {
    insertBreak();

    const blockAfter = editor.selection ? editor.api.block() : undefined;
    if (blockHasListStyle(blockAfter?.[0])) return;

    clearFieldMarksOnCurrentBlock(editor);
  },
}));

export const FieldClearMarksOnBreakKit = [FieldClearMarksOnBreakPlugin];
